import { Constants } from '../app.const';

export class SharedConstants {

    public static basicConstans = Constants;

    //API
    public static apiAuth: string = "auth/login";
    public static apilogin: string = "auth/user/login";
    public static apiGoogleLogin: string = "auth/googlelogin";

    //ROUTES

    //LINK

    //KEY
    public static keyToken: string = "token";

    public static keyContentType: string = "Content-Type";

    //VALUE
    public static valueContentType: string = "application/json";

}



// WEBPACK FOOTER //
// ./src/app/shared/shared.const.ts